import withRedux from './withRedux'
import withEffects from './withEffects'
import { compose } from 'redux'

export default compose(
  withRedux, // for getting/setting error message
  withEffects // for clearing error when navigation changes
)(() => null)
